<template>
  <div id="UserPortal" :key="rerenderCount">
    <Login v-if="session.authenticated ? false : true" />
    <Dashboard v-if="session.authenticated ? true : false" />
    <div id="CrazyBottom">
      <img :src="background" />
    </div>
  </div>
</template>

<script>
import api from "@/service/api";
import Login from "./components/Login.vue";
import Dashboard from "./components/Dashboard.vue";

export default {
  name: "UserPortal",
  components: {
    Login,
    Dashboard,
  },
  data() {
    return {
      rerenderCount: 0,
      session: window.portal.session,
      user: window.portal.user,
      background: process.env.VUE_APP_BACKGROUND_IMAGE,
    };
  },
  beforeCreate() {
    /* #### Global Functions #### */
  },
  created() {
    // assume that this colors are coming from an async ajax call
    api
      .getSettings()
      .then((data) => {
        this.setConfig(data);
      })
      .catch((e) => {
        console.log(e);
        this.setConfig({});
      });
  },
  mounted: function () {
    window.portal.rerender = this.ReRender;
    // If we already have a session, we can load the user
    if (sessionStorage.getItem('authenticated') && localStorage.getItem("auth-key") && localStorage.getItem("auth-user")) {
      window.portal.session.authenticated = true;
      window.portal.session.token = localStorage.getItem("auth-key");
      window.portal.user.id = localStorage.getItem("auth-user");
    } else {
      window.portal.login();
    }
  },
  methods: {
    ReRender() {
      this.rerenderCount += 1;
    },
    Logout() {
      window.portal.logout();
    },
    setConfig(config) {
      const colors = {
        primary: config.primary || process.env.VUE_APP_PRIMARY_COLOR,
        secondary: config.secondary || process.env.VUE_APP_SECONDARY_COLOR,
        background:
          config.backgroundColor || process.env.VUE_APP_BACKGROUND_COLOR,
      };
      this.setThemeColors(colors);
      this.background = config.background ? config.background : process.env.VUE_APP_BACKGROUND_IMAGE;
      window.portal.cover1 = config.cover1 ? config.cover1 : process.env.VUE_APP_COVER_IMAGE_1;
      window.portal.cover2 = config.cover2 ? config.cover2 : process.env.VUE_APP_COVER_IMAGE_2;
      window.portal.logo = config.logo ? config.logo : process.env.VUE_APP_LOGO;
      window.portal.small_logo = config.small_logo ? config.small_logo : process.env.VUE_APP_SMALL_LOGO;
      window.portal.current_event_id = config.current_event_id;
      window.portal.ticket_claiming_enabled = config.ticketClaimingEnabled;
    },
    setThemeColors(colors) {
      const style = document.documentElement.style;

      for (let key of Object.keys(colors)) {
        style.setProperty("--theme-color-" + key, colors[key]);
      }
    },
  },
  beforeUpdate: function () {
    /* #### Late Load Helpers #### */
  },
};
</script>

<style>
/* #### Defaults & Resets #### */
/* #### Resets #### */
html,
body {
  display: block;
  min-height: 100%;
  min-width: 100%;
  background: #23282d;
}
article,
aside,
details,
figcaption,
figure,
footer,
header,
hgroup,
main,
nav,
section,
summary {
  display: block;
}
audio,
canvas,
video {
  display: inline-block;
}
audio:not([controls]) {
  display: none;
  height: 0;
}
[hidden],
template {
  display: none;
}
html {
  font-family: sans-serif;
  -ms-text-size-adjust: 100%;
  -webkit-text-size-adjust: 100%;
}
body {
  margin: 0;
}
a {
  background: transparent;
}
a:focus {
  outline: thin dotted;
}
a:active,
a:hover {
  outline: 0;
}
h1 {
  font-size: 2em;
  margin: 0.67em 0;
}
abbr[title] {
  border-bottom: 1px dotted;
}
b,
strong {
  font-weight: 700;
}
dfn {
  font-style: italic;
}
hr {
  -moz-box-sizing: content-box;
  box-sizing: content-box;
  height: 0;
}
mark {
  background: #ff0;
  color: #000;
}
code,
kbd,
pre,
samp {
  font-family: monospace, serif;
  font-size: 1em;
}
pre {
  white-space: pre-wrap;
}
q {
  quotes: "\201C""\201D""\2018""\2019";
}
small {
  font-size: 80%;
}
sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}
sup {
  top: -0.5em;
}
sub {
  bottom: -0.25em;
}
img {
  border: 0;
}
svg:not(:root) {
  overflow: hidden;
}
figure {
  margin: 0;
}
fieldset {
  border: 1px solid silver;
  margin: 0 2px;
  padding: 0.35em 0.625em 0.75em;
}
legend {
  border: 0;
  padding: 0;
}
button,
input,
select,
textarea {
  font-family: inherit;
  font-size: 100%;
  margin: 0;
}
button,
input {
  line-height: normal;
}
button,
select {
  text-transform: none;
}
button,
html input[type="button"],
input[type="reset"],
input[type="submit"] {
  -webkit-appearance: button;
  cursor: pointer;
}
button[disabled],
html input[disabled] {
  cursor: default;
}
input[type="checkbox"],
input[type="radio"] {
  box-sizing: border-box;
  padding: 0;
}
input[type="search"] {
  -webkit-appearance: textfield;
  -moz-box-sizing: content-box;
  -webkit-box-sizing: content-box;
  box-sizing: content-box;
}
input[type="search"]::-webkit-search-cancel-button,
input[type="search"]::-webkit-search-decoration {
  -webkit-appearance: none;
}
button::-moz-focus-inner,
input::-moz-focus-inner {
  border: 0;
  padding: 0;
}
textarea {
  overflow: auto;
  vertical-align: top;
}
table {
  border-collapse: collapse;
  border-spacing: 0;
}
*,
:after,
:before {
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
html {
  font-size: 62.5%;
}
body {
  font: 300 11px/1.4 "Helvetica Neue", Helvetica, Arial, sans-serif;
  color: #444;
}
.clear:before,
.clear:after {
  content: " ";
  display: table;
}
.clear:after {
  clear: both;
}
.clear {
  *zoom: 1;
}
img {
  max-width: 100%;
  vertical-align: bottom;
}
a {
  color: #444;
  text-decoration: none;
}
a:hover {
  color: #444;
}
a:focus {
  outline: 0;
}
a:hover,
a:active {
  outline: 0;
}
input:focus {
  outline: 0;
  border: 1px solid #04a4cc;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  line-height: normal;
  margin: 0;
  padding: 0;
}
html,
body {
  display: block;
  margin: 0;
  padding: 0;
  height: 100%;
}
body {
  min-height: 100%;
  height: auto;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  margin: 0;
  padding: 0;
}
* {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  -webkit-box-sizing: border-box;
  -moz-box-sizing: border-box;
  box-sizing: border-box;
}
input,
button,
textarea,
select {
  font-size: 14px;
  padding: 5px 10px;
  margin: 5px;
  line-height: 1.8;
  vertical-align: middle;
}
/* ## Selection Color ## */
::-moz-selection,
::-webkit-selection,
::selection {
  background: #beba79;
  color: #fff;
  text-shadow: none;
}
/* ## Cursor ## */
a,
button,
input[type="button"],
input[type="submit"] {
  cursor: pointer !important;
}
/* ## Outline ## */
*.scrollto:focus,
*.scrollto:active {
  box-shadow: none !important;
  outline: none !important;
}
/* ## Img ## */
img {
  height: auto;
  width: 100%;
}

/* #### Main CSS Variables #### */
:root {
  --max-page-width: calc(1020px - 80px);
  --mobile-breakpoint: 650px; /* can't use for media queries yet :-( */
  --header-height: 50px;
  --side-margins: 20px;
  --vertical-margins: 20px;

  --background: #3584b5;
  --text-color: #000;
  --link-color: #000;
  --link-color-hover: #12cfd5;
  --header-color: #fff;

  --button-font-size: 16px;
  --button-border: 0px none;
  --button-text-color: #fff;
  --button-background: var(--theme-color-primary);
  --button-border-hover: 0px none;
  --button-text-color-hover: #fff;
  --button-background-hover: #1aa3ba;
  --button-padding: 5px 15px 0px;

  --navbar-background: var(--theme-color-primary);
  --navbar-text-color: #fff;
  --navbar-text-color-hover: #c8dc53;

  --mainpage-background: transparent;
  --mainpage-text-color: #fff;
  --mainpage-link-color: #fff;
  --mainpage-link-color-hover: #12cfd5;
  --mainpage-header-color: #fff;
  --mainpage-padding: 40px;
  --mainpage-divider: #fff;

  --box-background: rgba(255, 255, 255, 0.9);
  --box-text-color: #525252;
  --box-link-color: var(--theme-color-primary);
  --box-link-color-hover: #1aa3ba;
  --box-header-color: var(--theme-color-primary);
  --box-highlight-color: #1aa3ba;
  --box-padding: 20px;
  --box-divider: #dbdde1;
  --box-highlight: #d2cbff;

  --box-dark-background: var(--theme-color-primary);
  --box-dark-text-color: #fff;
  --box-dark-link-color: #fff;
  --box-dark-link-color-hover: #12cfd5;
  --box-dark-header-color: #fff;
  --box-dark-padding: 20px;
  --box-dark-divider: #fff;

  --box-light-background: #e2f7f7;
  --box-light-text-color: #000;
  --box-light-link-color: #544098;
  --box-light-link-color-hover: #544098;
  --box-light-header-color: #544098;
  --box-light-padding: 20px;
  --box-light-divider: #000;
}

/* #### Fonts #### */
@font-face {
  font-family: "Raleway";
  src: url("/fonts/raleway.eot");
  src: url("/fonts/raleway.eot?#iefix") format("embedded-opentype"),
    url("/fonts/raleway.woff2") format("woff2"),
    url("/fonts/raleway.woff") format("woff"),
    url("/fonts/raleway.ttf") format("truetype"),
    url("/fonts/raleway.svg#ralewayregular") format("svg");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "Oswald";
  src: url("/fonts/oswald.eot");
  src: url("/fonts/oswald.eot?#iefix") format("embedded-opentype"),
    url("/fonts/oswald.woff2") format("woff2"),
    url("/fonts/oswald.woff") format("woff"),
    url("/fonts/oswald.ttf") format("truetype"),
    url("/fonts/oswald.svg#oswaldregular") format("svg");
  font-weight: normal;
  font-style: normal;
}
body {
  font-family: "Raleway", Tahoma, Verdana, sans-serif;
  font-size: 16px;
  font-weight: normal;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Oswald", Tahoma, Verdana, sans-serif;
  line-height: 1.4;
  font-weight: bold;
  letter-spacing: normal;
}
h1 {
  font-size: 3em;
}
h2 {
  font-size: 2.25em;
}
h3 {
  font-size: 2em;
}
h4 {
  font-size: 1.8em;
}
h5 {
  font-size: 1.6em;
}
h6 {
  font-size: 1.4em;
}
button,
a.button {
  transition: all 0.3s ease 0.2s;
  display: inline-block;
  text-decoration: none;
  line-height: 1.4;
  font-size: var(--button-font-size);
  text-transform: uppercase;
  font-family: "Oswald", Tahoma, Verdana, sans-serif;
  padding: var(--button-padding);
}
button:hover,
a.button:hover {
  transition: all 0.3s ease 0.2s;
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
  -webkit-transform: scale(1.05);
  transform: scale(1.05);
}
button:disabled:hover,
a.button:disabled:hover {
  box-shadow: none;
  -webkit-transform: scale(1);
  transform: scale(1);
}
.button-row::after {
  content: "";
  display: block;
  clear: both;
}
form label {
  display: block;
  font-size: 14px;
  padding: 0px 10px;
}
form .row {
  display: block;
  padding: 20px 10px;
  box-sizing: border-box;
}
form .block {
  position: relative;
  display: inline-block;
  vertical-align: top;
  padding: 0px 10px;
  width: 50%;
  box-sizing: border-box;
}
form .block input,
form .block select {
  width: 100%;
}
@media only screen and (max-width: 650px) {
  form .block {
    width: auto;
    display: block;
  }
}

/* #### Gradient Background #### */
html {
  background: linear-gradient(
    to right,
    var(--theme-color-background),
    var(--theme-color-primary)
  );
}
body {
  background: linear-gradient(
    to right,
    var(--theme-color-background),
    var(--theme-color-primary)
  );
  height: auto !important;
}
#CrazyBottom {
  position: fixed;
  bottom: 0;
  clear: both;
  display: block;
  margin: 100% 0 0;
  padding: 0;
  text-align: center;
  min-width: 100%;
  min-height: 100%;
  z-index: 99;
}
#CrazyBottom img {
  min-width: 100%;
  min-height: 100%;
  max-width: unset;
  max-height: unset;
  width: auto;
  height: auto;
}

/* #### Colors #### */
body {
  color: var(--text-color);
}
a {
  color: var(--link-color);
}
a:hover {
  color: var(--link-color-hover);
}
h1,
h2,
h3,
h4,
h5,
h6 {
  color: var(--header-color);
}
button {
  display: inline-block;
  border: var(--button-border);
  background: var(--button-background);
  color: var(--button-text-color);
}
button:hover {
  border: var(--button-border-hover);
  background: var(--button-background-hover);
  color: var(--button-text-color-hover);
  cursor: pointer;
}
button:disabled {
  background: #666 !important;
  cursor: not-allowed !important;
}
.center {
  text-align: center;
}
.error,
.error:hover,
.required {
  color: #900 !important;
}
.success,
.success:hover {
  color: #009900 !important;
}
a.error,
a.error:hover {
  text-decoration: underline;
  color: #900 !important;
}
input.error {
  border: 1px solid #900;
}
.error-background {
  background: #fbe0d9;
}
.button-yes:hover {
  background: #090;
}
.button-no:hover {
  background: #900;
}
button i {
  margin: 0 6px 0 0;
}

/* #### Boxes #### */
.box {
  display: inline-block;
  position: relative;
  vertical-align: top;
  background: var(--box-background);
  position: relative;
  padding: var(--box-padding);
  box-sizing: border-box;
  color: var(--box-text-color);
  box-shadow: 0 10px 10px -10px rgba(0, 0, 0, 0.5);
}
.box > h2 {
  color: var(--box-header-color);
  border: 0 none;
  padding-bottom: 5px;
  margin-bottom: 5px;
  border-bottom: 1px solid var(--box-divider);
  vertical-align: bottom;
}
.box a {
  color: var(--box-link-color);
}
.box a:hover {
  color: var(--box-link-color-hover);
}
@media only screen and (max-width: 800px) {
  .box {
    padding-left: 15px;
    padding-right: 15px;
  }
}
/* ## Boxes: Dark ## */
.box.dark {
  background: var(--box-dark-background);
  padding: var(--box-dark-padding);
  color: var(--box-dark-text-color);
}
.box.dark > h2 {
  color: var(--box-dark-header-color);
}
.box.dark a {
  color: var(--box-dark-link-color);
}
.box.dark a:hover {
  color: var(--box-dark-link-color-hover);
}
/* ## Boxes: Light ## */
.box.light {
  background: var(--box-light-background);
  padding: var(--box-light-padding);
  color: var(--box-light-text-color);
}
.box.light > h2 {
  color: var(--box-light-header-color);
}
.box.light a {
  color: var(--box-light-link-color);
}
.box.light a:hover {
  color: var(--box-light-link-color-hover);
}

.transparent-box {
  background: rgba(255, 255, 255, 0.82);
  margin: 10px 12% 50px;
  border-radius: 8px;
  padding: 15px;
}
.transparent-box p {
  padding: 0 !important;
  margin: 15px 8px 15px 15px !important;
  font-size: 13px;
}

/* #### Layout #### */
.center {
  text-align: center;
}
.hide {
  display: none;
}
.float-left {
  float: left;
}
.clear-left {
  clear: left;
}
.float-right {
  float: right;
}
.clear-right {
  clear: right;
}
.clear,
.clear-both {
  clear: both;
}
.clear-after::after {
  content: "";
  display: block;
  clear: both;
  height: 0px;
}
.cols-2 {
  position: relative;
  vertical-align: top;
  padding: 0;
}
.cols-2 > *,
#page-main .cols-2 > *.box {
  width: calc((100% - 20px) / 2);
  display: inline-block;
  vertical-align: top;
  margin-left: 0;
  margin-left: 0;
  margin-right: 20px;
}
.cols-2 > *:last-child,
#page-main .cols-2 > *.box:last-child {
  margin-right: 0%;
}
@media only screen and (max-width: 650px) {
  .cols-2 > *,
  #page-main .cols-2 > *.box {
    width: auto;
    display: block;
    margin-right: 0;
  }
}

/* #### Messages #### */
.msg {
  border: 1px solid #666;
  margin: 10px 5px;
  padding: 10px 15px;
  background: #eee;
  color: #666;
  text-align: left;
  font-size: 14px;
}
.msg-error {
  border-color: #900;
  color: #900;
  background: #fbe0d9;
}
.msg-warn {
  border-color: #ffca28;
  color: #ffca28;
  background: #feffc0;
}
.msg-success {
  border-color: #090;
  color: #090;
  background: #ddfbdd;
}
.msg-important {
  border-color: var(--box-header-color);
  color: var(--box-header-color);
  background: var(--box-highlight);
}
</style>
